module.exports = __webpack_public_path__ + "img/7.35b347ec.png";